(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["grapesjs-tui-image-editor"] = factory();
	else
		root["grapesjs-tui-image-editor"] = factory();
})(window, function() {
return 